import { useQuery } from "@tanstack/react-query";
import { authFetch } from "../lib/auth";
import { useAuth } from '@/context/AuthContext';

export interface DailyActivity {
    date: string;
    count: number;
}

export interface UserProgressData {
    progress: {
        id: string;
        user_id: string;
        total_study_minutes: number;
        total_sessions: number;
        current_streak: number;
        longest_streak: number;
        total_xp: number;
        level: number;
        last_study_date: string | null;
    };
    daily_activity: DailyActivity[];
}

export const useUserProgress = () => {
    const { user } = useAuth();
    return useQuery({
        queryKey: ["user-progress", user?.id],
        enabled: !!user?.id,
        staleTime: 60_000,
        refetchOnWindowFocus: true,
        queryFn: async ({ signal }): Promise<UserProgressData> => {
            const res = await authFetch("/api/user/progress", { signal });
            if (!res.ok) {
                const payload = await res.json().catch(() => ({}));
                throw new Error(payload.error || "Failed to fetch user progress");
            }
            return res.json();
        },
    });
};
